import { CrudFilters, IResourceComponentsProps, useNotification, usePermissions, useShow } from "@pankod/refine-core";
import {
  List,
  Table,
  TextField,
  useTable,
  getDefaultSortOrder,
  Space,
  EditButton,
  DeleteButton,
  ShowButton,
  Modal,
  Show,
  Typography,
  CreateButton,
  Input,
  Form,
  Icons,
  Button,
  Row,
  Col,
} from "@pankod/refine-antd";
import { useState } from "react";
import { IMessageType } from "interfaces/message-type.interface";
import {
  IoNotifications,
  IoMail,
  IoCalendar,
  IoAlertCircle,
  IoInformationCircle,
  IoWarning,
  IoCheckmarkCircle,
  IoCloseCircle,
  IoDocumentText,
  IoFolder,
  IoHome,
  IoPerson,
  IoSchool,
  IoBook,
  IoNewspaper,
  IoMegaphone,
  IoTrophy,
  IoStar,
  IoHeart,
  IoGift,
} from "react-icons/io5";

const { Title, Text } = Typography;

// Mapa de nombres Expo/Ionicons (minúsculas) a componentes Ionicons
// Permite que la web muestre los iconos mientras Expo usa los mismos nombres
const iconMap: { [key: string]: any } = {
  "notifications": IoNotifications,
  "mail": IoMail,
  "calendar": IoCalendar,
  "alert-circle": IoAlertCircle,
  "information-circle": IoInformationCircle,
  "warning": IoWarning,
  "checkmark-circle": IoCheckmarkCircle,
  "close-circle": IoCloseCircle,
  "document-text": IoDocumentText,
  "folder": IoFolder,
  "home": IoHome,
  "person": IoPerson,
  "school": IoSchool,
  "book": IoBook,
  "newspaper": IoNewspaper,
  "megaphone": IoMegaphone,
  "trophy": IoTrophy,
  "star": IoStar,
  "heart": IoHeart,
  "gift": IoGift,
};

export const MessageTypeList: React.FC<IResourceComponentsProps> = () => {

  const { tableProps, sorter, searchFormProps } = useTable<IMessageType>({
    initialSorter: [
      {
        field: "id",
        order: "asc",
      },
    ],
    initialPageSize: 15,
    onSearch: (params: any) => {
      const filters: CrudFilters = [];
      const { q } = params;
      filters.push(
          {
              field: 'name_like',
              operator: 'eq',
              value: q,
          },
      );
      return filters;
    },
  });

  const [visible, setVisible] = useState(false);
  const { queryResult, showId, setShowId } = useShow<IMessageType>();
  const { data, isLoading } = queryResult;
  const record = data?.data;

  return (
    <>
      <List
        headerButtons={() => <CreateButton type="primary">Nuevo Tipo de Mensaje</CreateButton> }
      >
        <Form layout="vertical" {...searchFormProps}>
          <Row gutter={[20, 0]}>
            <Col span={12}>
              <Form.Item name="q">
                  <Input
                      placeholder="Tipo"
                      prefix={<Icons.SearchOutlined />}
                  />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item>
                  <Button htmlType="submit" type="primary">
                      Buscar
                  </Button>
              </Form.Item>
            </Col>
          </Row>
        </Form>
        <Table {...tableProps} rowKey="id">
          <Table.Column
            dataIndex="id"
            key="id"
            title="id"
            render={(value) => <TextField value={value} />}
            defaultSortOrder={getDefaultSortOrder("id", sorter)}
            sorter
          />
          <Table.Column<IMessageType>
            dataIndex="icon"
            key="icon"
            title="Icono"
            render={(_, record) => {
              if (!record.icon) return null;
              
              const IconComponent = iconMap[record.icon];
              if (!IconComponent) return null;

              return (
                <div
                  style={{
                    width: '40px',
                    height: '40px',
                    borderRadius: '50%',
                    backgroundColor: record.icon_background_color || '#f0f0f0',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}
                >
                  <IconComponent 
                    size={24}
                    color={record.icon_color || '#000000'}
                  />
                </div>
              );
            }}
          />
          <Table.Column
            dataIndex="type"
            key="type"
            title="Tipo"
            render={(value) => <TextField value={value} />}
            defaultSortOrder={getDefaultSortOrder("type", sorter)}
            sorter
          />
          <Table.Column<IMessageType>
            title="Acciones"
            dataIndex="actions"
            render={(_, record) => (
              <Space>
                <EditButton hideText size="small" recordItemId={record.id} />
                <ShowButton hideText size="small" recordItemId={record.id}  
                  onClick={() => {
                    setShowId(record.id);
                    setVisible(true);
                }} />
                <DeleteButton hideText size="small" recordItemId={record.id} />
              </Space>
            )}
          />
        </Table>
      </List>
      <Modal visible={visible} onCancel={() => setVisible(false)} onOk={() => setVisible(false)}>
        <Show 
          isLoading={isLoading}
          recordItemId={showId}
          headerProps={{
            title: 'Tipo de Mensaje'
          }}
          headerButtons={<></>}
        >
          <Title level={5}>ID</Title>
          <Text>{record?.id}</Text>
          <Title level={5}>Tipo</Title>
          <Text>{record?.type}</Text>
          {record?.icon && (
            <>
              <Title level={5}>Icono</Title>
              <div style={{ display: 'flex', alignItems: 'center', gap: '16px', marginBottom: '16px' }}>
                <div
                  style={{
                    width: '50px',
                    height: '50px',
                    borderRadius: '50%',
                    backgroundColor: record.icon_background_color || '#f0f0f0',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}
                >
                  {(() => {
                    const IconComponent = iconMap[record.icon];
                    return IconComponent ? (
                      <IconComponent 
                        size={28}
                        color={record.icon_color || '#000000'}
                      />
                    ) : null;
                  })()}
                </div>
                <div>
                  <div><strong>Nombre:</strong> {record.icon}</div>
                  <div><strong>Color:</strong> {record.icon_color || 'No definido'}</div>
                  <div><strong>Fondo:</strong> {record.icon_background_color || 'No definido'}</div>
                </div>
              </div>
            </>
          )}
        </Show>
      </Modal>
    </>
  );
};
